import React, { useState, useEffect } from 'react';
import toApp, { setup } from '@xpeng/to-app';
import { jumpPage } from '../../utils/common';
import './index.less';

function isSpecialAPP() {
  const ua = navigator.userAgent.toLowerCase();

  return (
    Boolean(ua.match(/MicroMessenger/gi)) || // 微信内置浏览器
    Boolean(ua.match(/dingtalk/gi)) || // 钉钉内置浏览器
    Boolean(ua.match(/weibo/gi)) || // 微博内置浏览器
    (ua.match(/\sqq/gi) && ua.indexOf('mqqbrowser') < 0) // QQ 内置浏览器
  );
}

const OpenTip = (props) => {
  const { jumpUrl, isJumpAppPage } = props;
  const [showTip, setShowTip] = useState(false);

  const openInSpecialAPP = isSpecialAPP();
  const targetUrl = encodeURIComponent(jumpUrl || window.location.href);

  setup({
    prompt: () => {
      setShowTip(true);
    }
  });

  const handleClick = () => {
    // 是否跳转app原生页面
    if (isJumpAppPage) {
      jumpPage(jumpUrl)
    } else { // 跳app的h5页面
      toApp(`activity/openurl?url=${targetUrl}`);
    }
  };

  useEffect(() => {
    if (openInSpecialAPP) {
      setShowTip(true);
    } else {
      handleClick();
    }
  }, []);

  return (
    <div className="forbidden-tip-wrapper">
      {showTip ? (
        <div className="open-in-browser-tip">点击选择浏览器打开</div>
      ) : null}
      <div className="open-tip-container">
        {openInSpecialAPP ? (
          <p className="tip-txt">请点击右上角分享按钮，选择浏览器打开</p>
        ) : (
          <>
            <p className="tip-txt">请打开「小鹏汽车App」扫码继续操作</p>
            <button className="opt-btn" onClick={handleClick}>
              打开小鹏汽车APP
            </button>
          </>
        )}
      </div>
      <div className="download-tip-container">
        <p className="tip-txt">还没有小鹏汽车APP ?</p>
        <a
          className="download-link"
          href="https://www.xiaopeng.com/m/download.html"
        >
          立即下载
        </a>
      </div>
    </div>
  );
};

export default OpenTip;
